import React from "react";
import AppRoutes from "../routes";
import HomePage from "../pages/whisky_house/home_page";
import Header from "../components/whisky_house/layouts/header";
import Footer from "../components/whisky_house/layouts/footer";
const WhiskyHouseTemplate = () => {
  return (
    <React.Fragment>
      <AppRoutes homePage={HomePage} />
      <Footer />
    </React.Fragment>
  );
};

export default WhiskyHouseTemplate;
